<template>
  <div>
    <div class="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
      </div>
      <!-- 如果需要分页器 -->
      <!-- <div class="swiper-pagination"></div> -->

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <!-- 上盒子 -->
    <!-- <div class="yy-box1">
      <ul>
        <li>
          <router-link to="/case/CaseSix">国机集团智能制造高峰论坛</router-link>
        </li>
        <li><router-link to="/case/CaseZJLY70">中机六院成立70周年</router-link></li>
        <li><router-link to="/case/Case713">客户公司成立60周年</router-link></li>
        <li><router-link to="/case/CaseDIY">中秋月饼DIY</router-link></li>
        <li><router-link to="/case/Case38">女神节的祝福</router-link></li>
      </ul>
    </div> -->
    <div class="all">
      <div style="display: flex; flex-direction: column">
        <div class="activity-sidebar">
          <div class="sidebar-title">重大活动</div>
          <ul class="activity-list">
            <li
              v-for="activity in activityList"
              :key="activity.id"
              @click="goToActivity(activity)"
              :class="{ active: activity.active }"
            >
              {{ activity.name }}
            </li>
          </ul>
        </div>
        <div class="activity-sidebar">
          <div class="sidebar-title">喜报</div>
          <ul class="activity-list">
            <router-link to="/honor/new8">
              <li
                v-for="activity in getInfoListXiBao"
                :key="activity.id"
                @click="choseNew(activity.id)"
              >
                {{ activity.mainTitle }}
                <!-- <span>{{ activity.publicationDate }}</span> -->
              </li>
            </router-link>
          </ul>
        </div>
      </div>

      <div style="flex:1;">
        <div class="news-bar">
          <div class="left-text">重大活动</div>

          <div class="right-text">
            <img
              src="../../assets/ryzs/weizhi.png"
              alt=""
              style="width: 20px; margin-right: 10px"
            />
            当前位置：

            <router-link to="/honor/myzs6">
              <div class="new_right">新闻动态</div>
            </router-link>
            <span>>></span>重大活动 <span>>></span>正文
          </div>
        </div>

        <h2 class="title">女神节的祝福</h2>
        <hr />
        <div class="main">
          <div class="content">
            <p>
              在这个充满爱与关怀的节日里，我们用心制作了一块块精美的蛋糕，旨在向身边的女神们传递我们的敬意、感激和祝福。
            </p>
            <!-- <p>首先，在制作蛋糕环节，大家齐心协力，共同完成了一个个精美的蛋糕。每一块蛋糕都寓意着我们对她们的敬意和感激，每一口都是我们对她们的爱意和祝福。蛋糕上的糖霜如同她们的笑容，甜美而温暖；蛋糕中的水果如同她们的生活，丰富多彩。在这个过程中，大家不仅体验到了亲手制作美食的乐趣，还增进了彼此之间的感情。</p>
            <p>接下来，在赠送奶茶环节，我们为她们送上了一杯杯热气腾腾的奶茶。奶茶中的奶香如同她们的爱，浓郁而深沉；茶香则象征着她们的智慧，清新而独特。这杯奶茶不仅仅是一种饮品，更是我们对她们的关爱和祝福的传递。</p>
            <p>整个活动充满了欢声笑语和温馨的氛围，让我们深刻体会到了女性在家庭和社会中的重要地位。通过这个活动，我们更加珍惜与她们相处的时光，愿她们在这个特殊的日子里感受到满满的幸福和关爱。</p> -->
          </div>
        </div>
        <div class="demo1-video">
          <!-- 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。 -->
          <!-- autoplay: "muted", //自动播放属性,muted:静音播放 -->
          <!-- preload="auto" //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。 -->
          <!-- poster="../assets/img/E0531.jpg"> //设置视频封面        -->
          <!-- <source :src="这里后台传回来的视频链接地址" type="video/mp4" >    //视频地址 -->
          <Video
            id="myVideo"
            class="myVideo"
            controls
            autoplay="muted"
            preload="auto"
            poster="../../assets/38/01.jpg"
          >
            <source src="../../assets/38/38.mp4" type="video/mp4" />
          </Video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      type:4,//喜报
      activityList: [
        { id: 1, name: '国机集团智能制造高峰论坛', path: '/case/CaseSix',active:false },
        { id: 2, name: '中机六院成立70周年', path: '/case/CaseZJLY70',active:false },
        { id: 3, name: '客户公司成立60周年', path: '/case/Case713',active:false },
        { id: 4, name: '中秋月饼DIY', path: '/case/CaseDIY',active:false },
        { id: 5, name: '女神节的祝福', path: '/case/Case38',active:true },
        { id: 6, name: '恒天重工双节问候', path: '/case/CaseHT',active:false },
        { id: 7, name: '冬至"饺"好运', path: '/case/Case713dz',active:false }
      ]
    };
  },
  computed: {
    ...mapState("myZs6", ['getInfoListXiBao']),
  },
  created() {
    this.getInfoAction(this.type)
  },
  mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        boxClass: "wow", ///动画元件css类（默认为wow）
        animateClass: "animated", //动画css类（默认为animated）
        offset: 0, //到元素距离触发动画（当默认为0）
        mobile: true, //在移动设备上触发动画（默认为true）
        live: true, //对异步加载的内容进行操作（默认为true）
      });
      wow.init();
    });
    new Swiper(".banner", {
      loop: true, //循环模式选项

      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // 如果需要滚动条
      //   scrollbar: {
      //     el: ".swiper-scrollbar",
      //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
  },
  methods: {
    ...mapActions("myZs6", ["getInfoAction"]),
    choseNew(id){
        localStorage.setItem('id',JSON.stringify(id))
    },
    goToActivity(activity) {
      // 跳转到对应活动详情页（这里使用路由 push）
      this.$router.push(activity.path);
      // 或者新窗口打开: window.open(activity.path, '_blank');
    }
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 3.5rem;
  overflow: hidden;
}
/* .banner:hover img {
  transform: scale(1.2);
} */
.banner img {
  /* transition: all 0.4s; */
  width: 100%;
  height: 100%;
  /* display: block;
  object-fit: cover; */
}
.yy-box1 {
  margin: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f6f6f6;
}

.all {
  display: flex;
  width: 100%;
  gap: 30px;
  justify-content: center;
  max-width: 80%;
  margin-left:10%;
}

/* 标题 */
.title {
  margin: 0.2rem 0;
  font-size: 0.13rem;
}
hr {
  width: 80%;
  margin: 0 auto;
}
.main {
  /* width: 60%; */
  /* background-color: pink; */
  margin: 0.1rem auto;
}
.content p {
  text-indent: 2em;
  text-align: center;
  font-size: 0.1rem;
  line-height: 0.18rem;
}
/* 视频 */
#myVideo {
  margin: 20px 0;
  width: 50%;
  height: 3rem;
}
/* source{
    width: 50%;
    height: 3rem;
} */

.news-bar {
  background-color: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 24px;
  font-family: "Microsoft YaHei", sans-serif;
  /* width: 60%; */
  /* margin-left: 20%; */
}
.left-text {
  font-weight: bold;
  color: #b62c28;
}
.right-text {
  color: #666;
  font-size: 16px;
  display: flex;
}
.right-text span {
  color: #999;
}

/* 左侧侧边栏 */
.activity-sidebar {
  width: 260px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: fit-content;
      margin: 20px 0;
}
.sidebar-title {
  background: linear-gradient(90deg, #f97316, #facc15);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 14px 0;
}
.activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.activity-list li {
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.activity-list li:hover {
  background: #fef3e2;
  color: #f97316;
}
.activity-list li:active {
  background: #fde6cc;
}
.active {
    background: #fef3e2;
  color: #f97316;
}
</style>
